import React, { Suspense, lazy,memo } from "react";
import { Navigate, useRoutes, useLocation } from "react-router-dom";

//import LogoOnlyLayout from '../layouts/LogoOnlyLayout';
import DashboardLayout from '../layouts/dashboard';
import LoadingScreen from '../components/LoadingScreen';
// guards
import LogoOnlyLayout from '../layouts/LogoOnlyLayout';
import GuestGuard from '../guards/GuestGuard';
import AuthGuard from '../guards/AuthGuard';
import UploadContact from "../pages/dashboard/contact/ListSidebar/uploadContacrt";
import Contact from "../pages/dashboard/contact/index";
import SettingContact from "../pages/dashboard/contact/ListSidebar/settingContact";
import ViewGuard from "../guards/ViewGuard";

const Loadable = (Component) => (props) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { pathname } = useLocation();
    const isDashboard = pathname.includes('/dashboard');

    return (
        <Suspense
            fallback={
                <LoadingScreen
                    sx={{
                        ...(!isDashboard && {
                            top: 0,
                            left: 0,
                            width: 1,
                            zIndex: 9999,
                            position: 'fixed'
                        })
                    }}
                />
            }
        >
            <Component {...props} />
        </Suspense>
    );
};
    export default memo( function Router() {
        
        return useRoutes([
            {
                path: 'auth',
                children: [
                    {
                        path: 'login',
                        element: (
                            <GuestGuard>
                                <Login />
                            </GuestGuard>
                        )
                    },
                    { path: 'login-unprotected', element: <Login /> },
                    { path: 'register-unprotected', element: <Register /> },
                    { path: 'reset-password', element: <ResetPassword /> },
                    // { path: 'verify', element: <VerifyCode /> }
                ]
            },
            {
                path: 'channel',
                element: (
                    <AuthGuard>
                        <DashboardLayout />
                    </AuthGuard>
                ),
                children: [
                    {
                        path: 'livechat',
                        children: [
                            {
                                path: 'chat',
                                element: (
                                    <AuthGuard>
                                        <LiveChat />
                                    </AuthGuard>
                                )
                            }
                        ]
                    },
                    {
                        path: 'zalo',
                        children: [
                            {
                                path: 'chat',
                                element: (
                                    <AuthGuard>
                                        <ChatZalo />
                                    </AuthGuard>
                                )
                            },
                            {
                                path: 'setting',
                                element: (
                                    <AuthGuard>
                                        <SettingZalo />
                                    </AuthGuard>
                                )
                            },
                        ]
                    },
                    {
                        path: 'facebook',
                        children: [
                            {
                                path: 'status',
                                element: (
                                    <AuthGuard>
                                        <UserProfileFacebook />
                                    </AuthGuard>
                                )
                            },
                            {
                                path: 'chat',
                                element: (
                                    <AuthGuard>
                                        <ChatFacebook />
                                    </AuthGuard>
                                )
                            },
                            {
                                path: 'setting',
                                element: (
                                    <AuthGuard>
                                        <SettingFacebook />
                                    </AuthGuard>
                                )
                            },
                            {
                                path: 'pages',
                                element: (
                                    <AuthGuard>
                                        <PagesFacebook />
                                    </AuthGuard>
                                )
                            },
                        ]
                    },
                ]
            },
            {
                path: 'notification',
                element: (
                    <AuthGuard>
                        <DashboardLayout />
                    </AuthGuard>
                ),
                children: [
                    { path: 'list', element: (<NotificationView />) },
                    // { path: 'detail/:notification_id', element: (<NotificationDetails />) },
                ]
            },

            {
                path: 'zalo',
                element: (
                    <AuthGuard>
                        <AccessZalo />
                    </AuthGuard>),
                children: []

            },
            {
                path: 'webhook',
                element: (
                    <AuthGuard>
                        <WebHook />
                    </AuthGuard>),
                children: []

            },
            {
                path: '/',
                element: (
                    <AuthGuard>
                        <DashboardLayout />
                    </AuthGuard>),
                children: [
                    {
                        path: 'settings',
                        element: (
                            <AuthGuard>
                                <Settings />
                            </AuthGuard>)
                    },
                    {
                        path: 'Configuration',
                        element: (
                            <AuthGuard>
                                <Configuration />
                            </AuthGuard>)
                    },
                    { path: '/', element: <GeneralApp /> }
                ]
            },
            {
                path: 'test',
                element: (
                    <AuthGuard>
                        <Test />
                    </AuthGuard>),
                children: []

            },
            {
                path: 'listCustomer',
                element: (
                    <ViewGuard>
                        <ListCustomer />
                    </ViewGuard>),
                children: []

            },
            {
                path: 'monitorDatabase',
                element: (
                    <ViewGuard>
                        <MonitorDataBase />
                    </ViewGuard>),
                children: []

            },
            {
                path: 'role',
                element: (
                    <AuthGuard>
                        <DashboardLayout />
                    </AuthGuard>),
                children: [
                    {
                        path: 'group-permission',
                        element: (
                            <AuthGuard>
                                <Permission />
                            </AuthGuard>)
                    },
                    {
                        path: 'create',
                        element: (
                            <AuthGuard>
                                <CreatePermission type="create" />
                            </AuthGuard>)
                    },
                    {
                        path: 'edit',
                        element: (
                            <AuthGuard>
                                <CreatePermission type="edit" />
                            </AuthGuard>)
                    },
                ]
            },
            {
                path: 'staff',
                element: (
                    <AuthGuard>
                        <DashboardLayout> </DashboardLayout>
                    </AuthGuard>
                ),
                children: [{
                    path: 'list',
                    element: (
                        <AuthGuard>
                            <UserList />
                        </AuthGuard>
                    )
                },]
            },
            {
                path: 'contact',
                element: (
                    <AuthGuard>
                        <DashboardLayout> </DashboardLayout>
                    </AuthGuard>
                ),
                children: [
                    {
                        path: 'staff',
                        element: (
                            <AuthGuard>
                                <UserList />
                            </AuthGuard>
                        )
                    },
                    {
                        path: 'edit',
                        element: (
                            <AuthGuard>
                                <EditContact />
                            </AuthGuard>
                        )
                    },
                    {
                        path: 'upload',
                        element: (
                            <AuthGuard>
                                <UploadContact />
                            </AuthGuard>
                        )
                    },
                    {
                        path: 'setting',
                        element: (
                            <AuthGuard>
                                <SettingContact />
                            </AuthGuard>
                        )
                    },
                    {
                        path: 'list',
                        element: (
                            <AuthGuard>
                                <ContactList />
                            </AuthGuard>
                        ),
                        // children: [
                        //     {
                        //         path: ':page',
                        //         element: (
                        //             <AuthGuard>
                        //                 <ContactList />
                        //             </AuthGuard>
                        //         )
                        //     }
                        // ]
                    }
                ]
            },
            {
                path: 'services',
                element: (
                    <AuthGuard>
                        <DashboardLayout />
                    </AuthGuard>
                ),
                children: [
                    {
                        path: 'smszns',
                        element: (
                            <AuthGuard>
                                <SmsZns />
                            </AuthGuard>
                        )
                    },
                    {
                        path: 'smszns/queue',
                        element: (
                            <AuthGuard>
                                <QueueCampaign />
                            </AuthGuard>
                        )
                    }
                ]
            },
            {
                path: 'pbx',
                element: (
                    <AuthGuard>
                        <DashboardLayout />
                    </AuthGuard>
                ),
                children: [
                    {
                        path: 'callhistory',
                        element: (
                            <AuthGuard>
                                <CallHistory />
                            </AuthGuard>
                        )
                    }
                ]
            },
            {
                path: 'ticket',
                element: (
                    <AuthGuard>
                        <DashboardLayout />
                    </AuthGuard>
                ),
                children: [
                    {
                        path: 'list',
                        element: (
                            <AuthGuard>
                                <Ticket />
                            </AuthGuard>
                        )
                    }
                ]
            },
            {
                path: 'statistic',
                element: (
                    <AuthGuard>
                        <DashboardLayout />
                    </AuthGuard>
                ),
                children: [
                    {
                        path: 'list',
                        element: (
                            <AuthGuard>
                                <Ticket />
                            </AuthGuard>
                        )
                    }
                ]

            },
            {
                path: 'janus',
                element: (
                    <AuthGuard>
                        <DashboardLayout />
                    </AuthGuard>
                ),
                children: [
                    {
                        path: 'test',
                        element: (
                            <AuthGuard>
                                <Testt />
                            </AuthGuard>
                        )
                    }
                ]
            },
            {
                path: 'report-dynamic',
                element: (
                    <AuthGuard>
                        <DashboardLayout />
                    </AuthGuard>
                ),
                children: [
                    {
                        path: 'list',
                        element: (
                            <AuthGuard>
                                <ReportList />
                            </AuthGuard>
                        )
                    },
                    {
                        path: 'view',
                        element: (
                            <AuthGuard>
                                <ReportView />
                            </AuthGuard>
                        )
                    },
                    {
                        path: 'create',
                        element: (
                            <AuthGuard>
                                <ReportCreate />
                            </AuthGuard>
                        )
                    }

                ]
            },
            {
                path: '*',
                element: <LogoOnlyLayout />,
                children: [
                    { path: '500', element: <Page500 /> },
                    { path: '404', element: <NotFound /> },
                    { path: '*', element: <Navigate to="/404" replace /> }
                ]
            },


            { path: '*', element: <Navigate to="/404" replace /> }
        ]);
    })

const Page500 = Loadable(lazy(() => import('../pages/Page500')));
const NotFound = Loadable(lazy(() => import('../pages/Page404')));
// Authentication
const Login = Loadable(lazy(() => import('../pages/authentication/Login')));
const Register = Loadable(lazy(() => import('../pages/authentication/Register')));
const ResetPassword = Loadable(lazy(() => import('../pages/authentication/ResetPassword')));
//const VerifyCode = Loadable(lazy(() => import('../pages/authentication/VerifyCode')));
//CHAT
const ChatZalo = Loadable(lazy(() => import('../pages/dashboard/zalo/Chat')));
const ChatFacebook = Loadable(lazy(() => import('../pages/dashboard/facebook/Chat')));
const PagesFacebook = Loadable(lazy(() => import('../pages/dashboard/facebook/Posts')));
const LiveChat = Loadable(lazy(() => import('../pages/dashboard/livechat/Chat')));
// const Chat = Loadable(lazy(() => import('../pages/dashboard/Chat')));
// const Chat = Loadable(lazy(() => import('../pages/dashboard/Chat')));
//STATUS
const UserProfileZalo = Loadable(lazy(() => import('../pages/dashboard/zalo/UserProfile')));
const UserProfileFacebook = Loadable(lazy(() => import('../pages/dashboard/facebook/UserProfile')));
//SETTING
const SettingZalo = Loadable(lazy(() => import('../pages/dashboard/zalo/Setting')));
const SettingFacebook = Loadable(lazy(() => import('../pages/dashboard/facebook/Setting')));
//ACCESS
const AccessZalo = Loadable(lazy(() => import('../pages/accessChannel/Zalo')));
//WebHook
const WebHook = Loadable(lazy(() => import('../pages/webhook/index')));

const Test = Loadable(lazy(() => import('../pages/test/index')));
const ListCustomer = Loadable(lazy(() => import('../pages/privateListCustomer/index')));
const MonitorDataBase = Loadable(lazy(() => import('../pages/privateListCustomer/monitorDatabase/index')));
const UserList = Loadable(lazy(() => import('../pages/userList/index')));
const ContactList = Loadable(lazy(() => import('../pages/dashboard/contact/index')));
const EditContact = Loadable(lazy(() => import('../pages/dashboard/contact/EditContact')));
const Settings = Loadable(lazy(() => import('../pages/settings/settings')));
const SmsZns = Loadable(lazy(() => import('../pages/services/SmsZns')));
const Permission = Loadable(lazy(() => import('../pages/permission/index')));
const CreatePermission = Loadable(lazy(() => import('../pages/permission/create')));
const Ticket = Loadable(lazy(() => import('../pages/ticket/index')));
const Testt = Loadable(lazy(() => import('../pages/Testt')));
const QueueCampaign = Loadable(lazy(() => import('../pages/services/Queue')));
const CallHistory = Loadable(lazy(() => import('../pages/pbx/CallHistory')));
//Notification
const NotificationView = Loadable(lazy(() => import('../pages/notification/index')));
//const NotificationDetails = Loadable(lazy(() => import('../pages/notification/modal/notificationDetails')));
const GeneralApp = Loadable(lazy(() => import('../pages/dashboard/GeneralApp')));

const Configuration = Loadable(lazy(() => import('../pages/configuration/index')));
const ReportView = Loadable(lazy(() => import('../pages/report/view/index')));
const ReportList = Loadable(lazy(() => import('../pages/report/index')));
const ReportCreate = Loadable(lazy(() => import('../pages/report/create/index')));
//pages